import {
  AddRequestJobsPage,
  EditRequestJobsPage,
  RequestHomePage,
  RequestJobListPage,
  RequestListPage,
} from 'support/pages';

import {
  addSupportRequestJobsPath,
  editSupportRequestJobsPath,
  supportRequestHomePath,
  supportRequestJobListPath,
  supportRequestListPath,
} from './routePaths';

export const supportRequestHome = {
  path: supportRequestHomePath(),
  exact: true,
  isPrivate: false,
  element: <RequestHomePage />,
};

export const supportRequestJobList = {
  path: supportRequestJobListPath(),
  exact: true,
  isPrivate: true,
  element: <RequestJobListPage />,
};

export const supportRequestList = {
  path: supportRequestListPath(),
  exact: true,
  isPrivate: true,
  element: <RequestListPage />,
};

export const supportRequestJobsAdd = {
  path: addSupportRequestJobsPath(),
  exact: true,
  isPrivate: true,
  element: <AddRequestJobsPage />,
};

export const supportRequestJobsEdit = {
  path: editSupportRequestJobsPath(),
  exact: true,
  isPrivate: true,
  element: <EditRequestJobsPage />,
};
